import { render, staticRenderFns } from "./CustomInputGroup.vue?vue&type=template&id=54dd325d&scoped=true"
import script from "./CustomInputGroup.vue?vue&type=script&lang=js"
export * from "./CustomInputGroup.vue?vue&type=script&lang=js"
import style0 from "./CustomInputGroup.vue?vue&type=style&index=0&id=54dd325d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dd325d",
  null
  
)

export default component.exports